import moment from "moment/moment";
import React from "react";
import { useNavigate } from "react-router";

const Portfolio = ({ item, url, currentPage = 0 }) => {
  const navigate = useNavigate();
  const moveToPage = (portNo) => {
    navigate(
      `/shop/${url}/portfolioView/${portNo}`,
      currentPage && { state: { page: currentPage } },
    );
  };

  return (
    <li key={item.id} onClick={() => moveToPage(item.portNo)}>
      <div className="image">
        <img src={imgHandler(item.imgUrl)} onError={onErrorImg} />
      </div>
      <div className="info">
        <span className="name">{item?.title ? item.title : ""}</span>
        <span className="date">{moment(item.createDt).format("YYYY-MM-DD")}</span>
      </div>
    </li>
  );
};

export default Portfolio;
